export default "__VITE_ASSET__abe06302__"